import { Button, Modal, Typography } from "antd";
import { NearbyPost } from "../utils/services/api";

interface NearbyPostsModalProps {
  open: boolean;
  posts: NearbyPost[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const NearbyPostsModal = ({
  open,
  posts,
  onConfirm,
  onCancel,
}: NearbyPostsModalProps) => {
  return (
    <Modal
      title="Demandas próximas encontradas"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button shape="round" key="cancel" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button shape="round" key="create" type="primary" onClick={onConfirm}>
          Criar mesmo assim
        </Button>,
      ]}
    >
      <Typography.Paragraph>
        Encontramos demandas com esse tema próximas a você. Alguma delas é sobre
        a solicitação que você pretende realizar? Caso seja, clique em
        &quot;Cancelar&quot;. Caso contrário, clique em &quot;Criar nova demanda
        mesmo assim&quot;.
      </Typography.Paragraph>
      {posts.map((post) => (
        <div
          key={post.id}
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: 16,
            padding: 12,
            border: "1px solid #f0f0f0",
            borderRadius: 8,
          }}
        >
          {post.photoUrl && (
            <img
              src={post.photoUrl}
              alt="demanda"
              style={{
                width: 80,
                height: 80,
                objectFit: "cover",
                borderRadius: 4,
                marginRight: 12,
              }}
            />
          )}
          <div style={{ flex: 1 }}>
            <Typography.Text strong>
              {post.address}
              {post.neighborhood ? ` - ${post.neighborhood}` : ""}
            </Typography.Text>
            <Typography.Paragraph
              ellipsis={{ rows: 2 }}
              style={{ marginBottom: 0, color: "#666" }}
            >
              {post.description}
            </Typography.Paragraph>
          </div>
        </div>
      ))}
    </Modal>
  );
};
